import { Helmet } from 'react-helmet'
import Background from './components/background'
import Container from './components/container'
import FormErrors from './components/form-errors'
import Form from './components/password-reset-form'

const PasswordReset = () => (
    <Container>
        <Helmet>
            <title>Reset Password | GIPHY</title>
        </Helmet>
        <Form />
        <Background />
        <FormErrors />
    </Container>
)

export default PasswordReset
